import { Component } from '@angular/core';
import type { EChartsOption } from 'echarts';

@Component({
    selector: 'app-instance-echart',
    templateUrl: './instance-echart.component.html',
    styleUrls: ['./instance-echart.component.scss']
})
export class InstanceEchartComponent {

    chartInstance: any;
    options: EChartsOption = {
        backgroundColor: '#2c343c',
        title: {
            text: 'Customized Pie',
            left: 'center',
            top: 20,
            textStyle: {
                color: '#ccc',
            }
        },
        tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        visualMap: {
            show: false,
            min: 80,
            max: 600,
            inRange: {
                colorLightness: [0, 1],
            },
        },
        series: [
            {
                name: 'Counters',
                type: 'pie',
                radius: '55%',
                center: ['50%', '50%'],
                data: [
                    { value: 335, name: 'C-1' },
                    { value: 310, name: 'C-2' },
                    { value: 274, name: 'C-3' },
                    { value: 235, name: 'C-4' },
                    { value: 400, name: 'C-5' },
                ].sort((a, b) => a.value - b.value),
                roseType: 'radius',
                label: {
                    color: 'rgba(255, 255, 255, 0.3)',
                },
                labelLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.3)',
                    },
                    smooth: 0.2,
                    length: 10,
                    length2: 20,
                },
                itemStyle: {
                    color: '#c23531',
                    shadowBlur: 200,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
                animationType: 'scale',
                animationEasing: 'elasticOut',
                animationDelay: () => Math.random() * 200,
            },
        ],
    };
    constructor() { }

    onChartInit(e: any) {
        this.chartInstance = e;
        console.log('on chart init:', e);
    }

}